/*global chrome*/
import React from 'react';
import { Link} from 'react-router-dom';
import Slider from "react-slick";
import API,{base} from "../../api.js";

const TestimonialSlider = {
  dots: false,
  arrows: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3.5,
  slidesToScroll: 1,
  // autoplay: true,
  autoplaySpeed: 3000,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1200, 
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 767, 
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};  
class Testimonial extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list:[]
        }
    }
    componentDidMount() {
        API({
              method: 'GET',
              url: "testimonial/list",
              data:'json',
            }).then(data => {
              this.setState({list:data.data.response.data});
            }).catch(()=>{
                this.setState({lockSubmit:false});
            });
    }
   
 render(){ 
	return (
	<section className="testimonials-section left-arrow-slider">      
        <h2 className="primary-heading text-center">Student <span>Testimonials</span></h2>
        <Slider {...TestimonialSlider}>
          {this.state.list.map((item)=>{
              return (<div className="testimonials-content" key={item.id}>
              <p>
                  {item.message}
              </p>
              <div className='user-info'>
                  <div className="user-img-outer">
                      <img className='user-img' src={base+item.image} alt="testimonial" />
                  </div>
                  <h3 className='user-name'>{item.name}</h3>
              </div>
          </div>);
          })}
        </Slider>
        <div className="d-flex justify-content-center">
          <Link className="primary-btn" to="/auth/register">
          <span className="btn-inner">
              REGISTER NOW
              <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
          </span>
          </Link>
        </div> 
    </section>
	);
}
}

export default Testimonial;